function showOnlineBankingField(fieldName) {
  $('.' + fieldName).removeClass('hidden');
}

function hideOnlineBankingField(fieldName) {
  $('.' + fieldName).addClass('hidden');
}

function hideBankNameSelector() {
  $('#bank_payout_transaction_bank_name').parent().parent().addClass('hidden');
}

function showBankNameSelector() {
  $('#bank_payout_transaction_bank_name').parent().parent().removeClass('hidden');
}

function isSpecificTransaction(trxName) {
  return Boolean($("form#new_".concat(trxName, "_transaction")).length > 0);
}

var Itau = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Itau') {
      if (terminal.payment_type === 'bank_to_bank') {
        hideOnlineBankingField('bank_payout_transaction_bank_province');
        hideOnlineBankingField('bank_payout_transaction_payer_bank_phone_number');
        hideOnlineBankingField('bank_payout_transaction_document_type');
        hideOnlineBankingField('bank_payout_transaction_bank_account_name');
        hideOnlineBankingField('bank_payout_transaction_user_id');
        hideOnlineBankingField('bank_payout_transaction_account_id');
        hideOnlineBankingField('bank_payout_transaction_id_card_number');
        hideOnlineBankingField('bank_payout_transaction_bank_account_verification_digit');
        showOnlineBankingField('bank_payout_transaction_document_id');
        showOnlineBankingField('bank_payout_transaction_bank_account_number');
        showOnlineBankingField('bank_payout_transaction_bank_account_type');
        showOnlineBankingField('bank_payout_transaction_bank_branch');
        showOnlineBankingField('bank_payout_transaction_bank_code');
        showBankNameSelector();
      }

      if (terminal.payment_type === 'pix') {
        hideOnlineBankingField('bank_payout_transaction_bank_province');
        hideOnlineBankingField('bank_payout_transaction_payer_bank_phone_number');
        hideOnlineBankingField('bank_payout_transaction_document_type');
        hideOnlineBankingField('bank_payout_transaction_bank_account_name');
        showOnlineBankingField('bank_payout_transaction_user_id');
        hideOnlineBankingField('bank_payout_transaction_account_id');
        hideOnlineBankingField('bank_payout_transaction_id_card_number');
        hideOnlineBankingField('bank_payout_transaction_bank_account_verification_digit');
        hideOnlineBankingField('bank_payout_transaction_document_id');
        hideOnlineBankingField('bank_payout_transaction_bank_account_number');
        hideOnlineBankingField('bank_payout_transaction_bank_account_type');
        hideOnlineBankingField('bank_payout_transaction_bank_branch');
        hideOnlineBankingField('bank_payout_transaction_bank_code');
        hideBankNameSelector();
      }
    }
  }
};
var SantanderBrazil = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'SantanderBrazil') {
      hideOnlineBankingField('bank_payout_transaction_bank_province');
      hideOnlineBankingField('bank_payout_transaction_payer_bank_phone_number');
      hideOnlineBankingField('bank_payout_transaction_document_type');
      hideOnlineBankingField('bank_payout_transaction_user_id');
      hideOnlineBankingField('bank_payout_transaction_account_id');
      hideOnlineBankingField('bank_payout_transaction_id_card_number');
      showOnlineBankingField('bank_payout_transaction_document_id');
      showOnlineBankingField('bank_payout_transaction_bank_account_verification_digit');

      if (isSpecificTransaction('boleto')) {
        hideOnlineBankingField('national_id');
        showOnlineBankingField('document_id');
      }
    } else {
      showOnlineBankingField('bank_payout_transaction_bank_province');
      showOnlineBankingField('bank_payout_transaction_payer_bank_phone_number');
      showOnlineBankingField('bank_payout_transaction_document_type');
      showOnlineBankingField('bank_payout_transaction_user_id');
      showOnlineBankingField('bank_payout_transaction_account_id');
      hideOnlineBankingField('bank_payout_transaction_document_id');
      showOnlineBankingField('bank_payout_transaction_id_card_number');
      hideOnlineBankingField('bank_payout_transaction_bank_account_verification_digit');
    }
  }
};
var DLocal = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Dlocal') {
      $('#bank_payout_params').removeClass('hidden');
      $('#beneficiary_name').removeClass('required').removeClass('hidden');
      $('#beneficiary_name .form-group label').removeClass('required');
      $('#consumer_reference_param').removeClass('required').addClass('hidden');
      $('#consumer_reference_param .form-group label').removeClass('required');

      if (isSpecificTransaction('upi')) {
        hideOnlineBankingField('vpa');
      }
    } else {
      $('#bank_payout_params').addClass('hidden');
      $('#beneficiary_name').addClass('required').addClass('hidden');
      $('#beneficiary_name .form-group label').addClass('required');
      $('#consumer_reference_param').addClass('required').removeClass('hidden');
      $('#consumer_reference_param .form-group label').addClass('required');
    }
  }
};
var Razorpay = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Razorpay' && isSpecificTransaction('upi')) {
      showOnlineBankingField('vpa');
    } else {
      showOnlineBankingField('bank-code');
    }
  }
};
var PayUIndia = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'PayUIndia' && isSpecificTransaction('upi')) {
      showOnlineBankingField('vpa');
    } else {
      showOnlineBankingField('bank-code');
    }
  }
};
var PandaPay = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'PandaPay') {
      hideOnlineBankingField('bank-code');
      hideOnlineBankingField('vpa');
    }
  }
};
var WeChat = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Wechat') {
      $('#product_params').addClass('hidden');
    } else {
      $('#product_params').removeClass('hidden');
    }
  }
};
var Sofort = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Sofort') {
      $('.bank_account_number').removeClass('hidden');
    } else {
      $('.bank_account_number').addClass('hidden');
    }
  }
};
var Neosurf = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Neosurf') {
      $('.voucher_number').addClass('hidden');
      $('.voucher_number .control-label').removeClass('required');
    } else {
      $('.voucher_number').removeClass('hidden');
      $('.voucher_number .control-label').addClass('required');
    }
  }
};
var Girogate = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Girogate') {
      showOnlineBankingField('consumer_reference');
      showOnlineBankingField('bank_code');
      showOnlineBankingField('birth_date');

      if (isSpecificTransaction('boleto')) {
        showOnlineBankingField('national_id');
      }
    } else {
      hideOnlineBankingField('consumer_reference');
      showOnlineBankingField('national_id');
      hideOnlineBankingField('bank_code');
      hideOnlineBankingField('birth_date');
    }
  }
};
var Gigadat = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Gigadat') {
      showOnlineBankingField('user_id');
    } else if (terminal.gateway !== 'Azupay' && terminal.gateway !== 'Gigadat') {
      hideOnlineBankingField('user_id');
    }
  }
};
var Azupay = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'Azupay') {
      showOnlineBankingField('user_id');
    } else if (terminal.gateway !== 'Azupay' && terminal.gateway !== 'Gigadat') {
      hideOnlineBankingField('user_id');
    }
  }
};
var PaysafeCard = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    if (terminal.gateway === 'PaysafeCard') {
      $('.customer_id').removeClass('hidden');
      $('.customer_id .control-label').addClass('required');
    } else {
      $('.customer_id').addClass('hidden');
      $('.customer_id .control-label').removeClass('required');
    }
  }
};
var FitBank = {
  updateOptionalFields: function updateOptionalFields(terminal) {
    var pixFieldClasses = ['pix_mothers_name', 'pix_birth_date', 'pix_gender', 'pix_marital_status', 'pix_sender_occupation', 'pix_nationality', 'pix_country_of_origin', 'pix_birth_city', 'pix_birth_state', 'pix_incorporation_date', 'pix_company_type', 'pix_company_activity'];

    if (terminal.gateway === 'FitBank') {
      if (isSpecificTransaction('boleto')) {
        hideOnlineBankingField('national_id');
        showOnlineBankingField('document_id');
      }

      if (['bank_to_bank', 'bank_to_bank_b2b'].includes(terminal.payment_type)) {
        hideOnlineBankingField('bank_payout_transaction_bank_province');
        hideOnlineBankingField('bank_payout_transaction_payer_bank_phone_number');
        hideOnlineBankingField('bank_payout_transaction_document_type');
        hideOnlineBankingField('bank_payout_transaction_user_id');
        hideOnlineBankingField('bank_payout_transaction_account_id');
        hideOnlineBankingField('bank_payout_transaction_id_card_number');
        hideOnlineBankingField('bank_payout_transaction_pix_key');
        hideOnlineBankingField('bank_payout_transaction_company_type');
        hideOnlineBankingField('bank_payout_transaction_company_activity');
        hideOnlineBankingField('bank_payout_transaction_incorporation_date');
        showOnlineBankingField('bank_payout_transaction_bank_account_number');
        showOnlineBankingField('bank_payout_transaction_bank_branch');
        showOnlineBankingField('bank_payout_transaction_bank_code');
        showOnlineBankingField('bank_payout_transaction_document_id');
        showOnlineBankingField('bank_payout_transaction_bank_account_verification_digit');
        showOnlineBankingField('bank_payout_transaction_bank_account_name');
        showOnlineBankingField('bank_payout_transaction_bank_account_type');
        showBankNameSelector();
      }

      if (['pix', 'pix_b2b'].includes(terminal.payment_type)) {
        showOnlineBankingField('bank_payout_transaction_pix_key');
        showOnlineBankingField('bank_payout_transaction_document_id');
        showOnlineBankingField('bank_payout_transaction_bank_account_name');
        hideOnlineBankingField('bank_payout_transaction_bank_province');
        hideOnlineBankingField('bank_payout_transaction_payer_bank_phone_number');
        hideOnlineBankingField('bank_payout_transaction_document_type');
        hideOnlineBankingField('bank_payout_transaction_bank_account_type');
        hideOnlineBankingField('bank_payout_transaction_account_id');
        hideOnlineBankingField('bank_payout_transaction_user_id');
        hideOnlineBankingField('bank_payout_transaction_id_card_number');
        hideOnlineBankingField('bank_payout_transaction_bank_account_verification_digit');
        hideOnlineBankingField('bank_payout_transaction_bank_account_number');
        hideOnlineBankingField('bank_payout_transaction_bank_branch');
        hideOnlineBankingField('bank_payout_transaction_bank_code');
        hideOnlineBankingField('bank_payout_transaction_company_type');
        hideOnlineBankingField('bank_payout_transaction_company_activity');
        hideOnlineBankingField('bank_payout_transaction_incorporation_date');
        hideOnlineBankingField('bank_payout_transaction_bank_gender');
        hideOnlineBankingField('bank_payout_transaction_bank_marital_status');
        hideOnlineBankingField('bank_payout_transaction_bank_sender_occupation');
        hideOnlineBankingField('bank_payout_transaction_bank_nationality');
        hideOnlineBankingField('bank_payout_transaction_bank_country_of_origin');
        hideOnlineBankingField('bank_payout_transaction_bank_birth_city');
        hideOnlineBankingField('bank_payout_transaction_bank_birth_state');
        hideBankNameSelector();
      }

      if (['bank_to_bank_b2b', 'pix_b2b'].includes(terminal.payment_type)) {
        showOnlineBankingField('bank_payout_transaction_company_type');
        showOnlineBankingField('bank_payout_transaction_company_activity');
        showOnlineBankingField('bank_payout_transaction_incorporation_date');
      }

      if (isSpecificTransaction('pix')) {
        pixFieldClasses.forEach(showOnlineBankingField);
      }
    } else {
      pixFieldClasses.forEach(hideOnlineBankingField);
    }
  }
};
var OptionalFields = {
  DLocal: DLocal,
  Razorpay: Razorpay,
  PayUIndia: PayUIndia,
  PandaPay: PandaPay,
  WeChat: WeChat,
  Sofort: Sofort,
  Neosurf: Neosurf,
  Girogate: Girogate,
  Gigadat: Gigadat,
  SantanderBrazil: SantanderBrazil,
  Itau: Itau,
  Azupay: Azupay,
  PaysafeCard: PaysafeCard,
  FitBank: FitBank
};
export default OptionalFields;